<div
  class="
    language-switch
    position-relative
    overflow-visible
    z-3
  ">

  <lib-input
    inputType="dropdown"
    inputClass="lang-switch"
    dropdownToggleClass="w-auto px-2 px-sm-3"
    dropdownAlign="inline-start"
    [label]="''"
    [showLabel]="false"
    [showPlaceHolder]="false"
    [items]="languages"
    valueKey="shortName"
    labelKey="name"
    [ngModel]="selectedLanguage"
    (ngModelChange)="selectLanguage($event)">

    <ng-template #selectedItemTemplate>
      <div
        class="
          d-flex
          align-items-center
          overflow-hidden
        ">

        <i
          class="
            icon-language
            fs-4
            flex-shrink-0
          "
          aria-hidden="true">
        </i>
        <span
          class="
            d-inline
            d-sm-none
            mx-2
            text-uppercase
            text-nowrap
            fs-7
          ">
          {{ selectedLanguage }}
        </span>
        <span
          class="
            d-none
            d-sm-inline
            mx-2
            text-truncate
            fs-7
          ">
          {{ selectedLanguageName }}
        </span>
      </div>
    </ng-template>

    <ng-template
      #itemTemplate
      let-language
      let-selected="selected">

      <div
        class="
          d-flex
          justify-content-between
          align-items-center
          w-100
          p-3
        ">

        <span class="m-0 mx-2 text-nowrap">
          {{ getLanguageName(language) }}
        </span>

        <input
          class="
            form-check-input
            m-0
            pe-none
            flex-shrink-0
          "
          type="radio"
          tabindex="-1"
          [checked]="
            selected ||
            selectedLanguage === language.shortName
          "
          [attr.aria-label]="getLanguageName(language)">
      </div>
    </ng-template>

  </lib-input>
</div>
